import React, { Component } from 'react'
import { Card } from '@myxplor/ui'

import List from '../ui/list'
import { Toggles as ActiveFilterToggles } from '../ui/active-filter'
import NavigateByWeek from '../ui/navigate-by-week'
import { dayFormat } from '../week'
import { getRegHolder, urlName } from '../reg-holder'
import LocalAsyncStore from '../local-async-store'

import SessionSummariesList from '../session-summaries/views'
import SessionSummariesSyncButtons from './views/sync-buttons'
import PaymentDetails from './details'

import { RegHolderName } from '../layout'
import EmptyPayments from './views/empty'
import ExpiryMessage from '../ui/expiry-message'

export const apiEndPoint = ({ record_type, id, start_date }) =>
  `/api/${record_type}/${id}/session-summaries?week=${dayFormat(start_date)}`

export const filterShape = ({ child, enrolment_status, submission_status }) => ({
  enrolment_status,
  submission_status,
  name: [child.first_name, child.last_name].join(' '),
  last_name: child.last_name,
})

export class PaymentSessionSummaries extends Component {
  render() {
    const {
      session_summaries,
      base_url,
      id,
      embedded,
      start_date,
      refresh_session_summaries,
    } = this.props

    const regHolder = getRegHolder(base_url, id)

    return (
      <Card
        embedded={embedded}
        title={
          <ActiveFilterToggles>
            <RegHolderName />
          </ActiveFilterToggles>
        }>
        <ExpiryMessage service_id={id}/>
        <SessionSummariesSyncButtons
          regHolder={regHolder}
          start_date={dayFormat(start_date)}
          onComplete={() =>
            refresh_session_summaries(
              apiEndPoint({
                record_type: urlName(regHolder),
                id,
                start_date,
              })
            )
          }
        />

        <NavigateByWeek base_url={base_url} start_date={start_date} view_type="Payments" />

        <List
          base_url={`${base_url}/${dayFormat(start_date)}`}
          records={session_summaries.data || []}
          loading={session_summaries.loading}
          listComponent={SessionSummariesList}
          detailComponent={PaymentDetails}
          emptyComponent={EmptyPayments}
          filterOn={filterShape}
        />
      </Card>
    )
  }
}

export default LocalAsyncStore('session_summaries', PaymentSessionSummaries, apiEndPoint)



// WEBPACK FOOTER //
// ./src/payments/container.js